import { segment } from '@actions/analytics';
import { emptyObject } from '@constants/empty';
import { KYCState, OnboardingFlow } from '@educator/Onboard/constants';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getMe } from '@selectors/auth';

const useDPPEvents = () => {
  const educator = useSelectorWithShallowEqual(getMe);
  const { username, isPlusEducator, uid, userID, isActive, kycDetails } =
    educator || emptyObject;
  const onboarding = useSelectorWithShallowEqual(
    ({ educatorOnboarding }) => educatorOnboarding
  );

  return (actionKey, additionalProps = {}) => {
    segment.track(actionKey, {
      educator_username: username ?? 'NA',
      educator_type: isPlusEducator ? 'Plus Educator' : 'Educator',
      educator_uid: uid ?? 'NA',
      educator_id: userID ?? 'NA',
      educator_status: isActive ? 'Active' : 'Inactive',
      is_kyc_done:
        kycDetails?.state === KYCState.VERIFIED ||
        onboarding?.onboardingState === OnboardingFlow.KYC_DONE,
      ...additionalProps
    });
  };
};

export default useDPPEvents;
